module.exports = __webpack_public_path__ + "static/media/Frame.759a3853.svg";